import { formatRelativeNL } from "../../lib/admin/formatters";

export function RelativeTime({ when }: { when: Date | null }) {
  return (
    <time
      dateTime={when ? when.toISOString() : undefined}
      title={when ? when.toLocaleString("nl-NL") : "nooit"}
    >
      {formatRelativeNL(when)}
    </time>
  );
}
